import { Breadcrumb } from 'shared/types/Breadcrumb'
import { MosaicFooterLink, MosaicFooterResponse } from 'shared/types/MosaicFooter'

const SECTION_LINKS_SLUG = 'footer/sectionLinks'
const LEGAL_LINKS_SLUG = 'footer/legalLinks'

const toLinkBreadcrumb =
  (parentSlug: string) =>
  ({ label, url }: MosaicFooterLink, index: number): Breadcrumb => ({
    name: label,
    // Slugs must stay unique for React keys; the URL drives navigation.
    slug: `${parentSlug}/${index}-${url}`,
    urlOverride: url,
  })

export const toFooterBreadcrumb = (response: MosaicFooterResponse): Breadcrumb => {
  const sections = (response?.main?.sections ?? response?.sections ?? []).map(
    (section, sectionIndex) => {
      const sectionSlug = `${SECTION_LINKS_SLUG}/${sectionIndex}-${section.label}`

      return {
        children: (section.links ?? []).map(toLinkBreadcrumb(sectionSlug)),
        name: section.label,
        slug: sectionSlug,
        ...(section.url && { urlOverride: section.url }),
      }
    },
  )

  const legalLinks = (response?.legal?.links ?? response?.legalLinks ?? []).map(
    toLinkBreadcrumb(LEGAL_LINKS_SLUG),
  )

  return {
    children: [
      { children: sections, name: 'Section Links', slug: SECTION_LINKS_SLUG },
      { children: legalLinks, name: 'Legal Links', slug: LEGAL_LINKS_SLUG },
    ],
    name: 'Footer',
    slug: 'footer',
  }
}
